import { navigateToPage } from 'libs/utils/window';
import { CHECKOUT_LOAD_TIME_TRACKING_DETAILS_STORAGE_KEY } from 'constants/checkout';
import { extraServiceOrderTypeToTrackingTypeMap } from 'constants/extra-service';
import { SINGLE_CHECKOUT_URL } from 'constants/routes';
import { setLocalStorageItem } from './localStorage';
export const markCheckoutLoadStartTime = _ref => {
  let {
    itemId
  } = _ref;
  const loadTimeStartStamp = new Date().getTime();
  const trackingDetails = {
    itemId,
    loadTimeStartStamp
  };
  setLocalStorageItem(CHECKOUT_LOAD_TIME_TRACKING_DETAILS_STORAGE_KEY, JSON.stringify(trackingDetails));
};
export const navigateToSingleCheckout = (orderId, orderType) => {
  const type = extraServiceOrderTypeToTrackingTypeMap[orderType];
  navigateToPage(SINGLE_CHECKOUT_URL(orderId, type));
};